// @params
// modelData:
//   {
//     members: [
//       id: xxx,
//       email: 'xxxx',
//       name: 'bbbb'
//     ],
//     objStagings: [
//       id: xxx,
//       title: 'xxxx',
//       member_id: 1
//     ]
//   }

export default function saveModelDatatoStore(storeRegistry, modelData) {
  Object.keys(modelData).forEach((modelName) => {
    const store = storeRegistry.getStore(modelName)

    if (store) {
      saveResourcesToStore(store, modelData[modelName])
    } else {
      console.warn(
        `No store found or store lacks saveResources action for model "${modelName}"`
      )
    }
  })
}

export const saveResourcesToStore = (store, data) => {
  data.forEach((newResource, index) => {
    saveResourceToStore(store, newResource)
  })
}

export const saveResourceToStore = (store, newResource) => {
  const index = store.resources.findIndex((resource) => {
    return resource.id === newResource.id
  })

  if (index > -1) {
    store.resources[index] = newResource
  } else {
    store.resources.push(newResource)
  }
}
